<template>
  <section class="address-list">
    <GateDeleteConfirm
      v-if="deleteConfirmOpened"
      :selected-count="rowsSelected.length"
      :loading="$store.getters.isLoading"
      @close="onDeleteConfirmClose"
      @approve="onDeleteConfirmApprove"
    />
    <div class="address-list__filters">
      <Filters v-model="filtersActive" :filters="filters" />
    </div>
    <div class="address-list__list">
      <Table
        v-model="rowsSelected"
        :columns="tableColumns"
        :rows="tableRows"
        @rowClick="onRowClick"
      />
      <Pagination
        v-model="currentPage"
        v-bind="pagination"
        @switchPage="onSwitchPage"
      />
    </div>
    <div class="address-list__actions">
      <Actions
        :actions="rowsSelected.length ? actions.selected : actions.default"
      />
    </div>
  </section>
</template>

<script>
import Filters from '../../components/Filters.vue'
import Table from '../../components/Table.vue'
import Actions from '../../components/Actions.vue'
import MockGateAddressList from '../../mixins/Mock/MockGateAddressList.js'
import MockPagination from '../../mixins/Mock/MockPagination.js'
import Pagination from '../../components/Pagination.vue'
import GateDeleteConfirm from '../Popup/GateDeleteConfirm.vue'

export default {
  name: 'AddressList',
  mixins: [MockGateAddressList, MockPagination],
  components: { Filters, Table, Actions, Pagination, GateDeleteConfirm },
  data() {
    return {
      filtersActive: {},
      rowsSelected: [],
    }
  },
  watch: {
    filtersActive: {
      handler(value) {
        this.filterGate({
          ...value,
          property_ids: value.property_ids ?? '',
          sigur_server_ids: value.sigur_server_ids ?? '',
        })
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.address-list {
  &__filters {
    margin: 0px $space-md $space-lg;
  }

  &__list {
    margin: 0px $space-md $space-lg;
  }
}
</style>
